import React, { useEffect, useRef } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Box, CircularProgress } from "@mui/material";

import { loadPortfolios, selectIsPageLoading } from "store/slices/app";
import { selectUser, selectMenu, selectLoading } from "store/slices/app";
import { selectPartnersData, setSelectedPartner } from "store/slices/app";

import { signOut } from "store/slices/authPages";
import Sidebar from "components/layout/Sidebar";
import Header from "../../components/layout/Header";
import { setEnvironment } from "store/slices/app";
import Footer from "components/layout/Footer";

const sx = {
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100vh"
  },

  main: {
    display: "flex",
    height: "100%",
    width: "100%",
    position: "fixed",
    top: "80px"
  },

  content: {
    flexGrow: 1,
    padding: "60px 80px",
    marginBottom: "60px",
    overflow: "scroll",
    display: "flex",
    flexDirection: "column"
  },

  outlet: {
    flexGrow: 1
  },
  outletLoading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
};

const HomePage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const contentRef = useRef(null);

  const loading = useSelector(selectLoading);
  const isPageLoading = useSelector(selectIsPageLoading);
  const partnersData = useSelector(selectPartnersData);
  const user = useSelector(selectUser);
  const userPartnerId = user.selectedPartner.id;
  const menuItems = useSelector(selectMenu);
  const logoUrl = user.selectedPartner.logoURI;
  const name = user.name;
  const companyName = user.selectedPartner.name;
  const currentPath = location.pathname;
  const userAccessRole = user.userAccessRole;

  useEffect(() => {
    contentRef.current.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (user.environment === "production") {
      dispatch(loadPortfolios(user.selectedPartner.id));
    }
  }, [dispatch, user.selectedPartner.id, user.environment]);

  useEffect(() => {
    if (currentPath === "/") {
      user.environment === "production"
        ? user.role === "STAFF_SUPER_USER"
          ? navigate("/business-lookup")
          : navigate("/business-lookup")
        : navigate("/system-level-settings/access-administration");
    }
  }, [navigate, currentPath, user.environment, user.role]);
  // this fix is for demo , need to refactor

  function handleLogout() {
    dispatch(signOut());
    navigate("/sign-in");
  }

  function onClick(path) {
    if (path) {
      navigate(path);
    }
  }

  function handleSwitch(_, value) {
    dispatch(setEnvironment(value));
  }

  function handlePartnerChange(event) {
    dispatch(setSelectedPartner(event.target.value));
  }

  const outletSx = [sx.outlet];
  if (loading) outletSx.push(sx.outletLoading);

  return (
    <Box sx={sx.root}>
      <Header
        name={name}
        companyName={companyName}
        companyLogoUrl={logoUrl}
        userType={user.type}
        isSuperUser={user.isSuperUser}
        environment={user.environment}
        partners={partnersData.partners}
        selectedPartner={partnersData.selectedPartner}
        isPartnerChanged={partnersData.isPartnerChanged}
        isPageLoading={isPageLoading}
        onLogout={handleLogout}
        onSwitch={handleSwitch}
        onPartnerChange={handlePartnerChange}
        userAccessRole={userAccessRole}
        userPartnerId={userPartnerId}
      />
      <Box sx={sx.main}>
        <Box>
          <Sidebar menuItems={menuItems} currentPath={currentPath} onClick={onClick} />
        </Box>
        <Box sx={sx.content} ref={contentRef}>
          <Box sx={outletSx}>{loading ? <CircularProgress /> : <Outlet />}</Box>
          <Footer />
        </Box>
      </Box>
    </Box>
  );
};

export default HomePage;
